module["exports"] = [
  "Sverige"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sv/address/default_country.js
// module id = 1734
// module chunks = 1